/** Constantes UI chat interno workspace (herramienta común). */

export const WORKSPACE_CHAT_POLL_MS = 12000;

export const WORKSPACE_CHAT_EMOJIS = [
  "😀", "😊", "😂", "🙂", "😉", "😅", "👍", "👏", "🙏", "❤️",
  "🔥", "✅", "❌", "⚠️", "📌", "📎", "📁", "💡", "🎉", "👋",
  "🤝", "💬", "📅", "⏰", "✨", "🚀",
];

export const WORKSPACE_CHAT_MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const WORKSPACE_CHAT_MAX_ATTACHMENTS_PER_MESSAGE = 5;
export const WORKSPACE_CHAT_ATTACHMENT_ACCEPT =
  ".pdf,.xml,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,application/pdf,image/jpeg,image/png,application/xml,text/xml";

/** URL de descarga de adjunto (misma API autenticada). */
export function buildWorkspaceChatAttachmentDownloadPath(attachmentId) {
  const id = String(attachmentId || "").trim();
  return id ? `/workspace/chat/attachments/${encodeURIComponent(id)}` : "";
}

/** Validación ligera en cliente antes de subir. */
export function validateWorkspaceChatAttachmentFile(file) {
  if (!file) return "Seleccione un archivo.";
  if (file.size <= 0) return "El archivo está vacío.";
  if (file.size > WORKSPACE_CHAT_MAX_ATTACHMENT_BYTES) {
    return "El adjunto supera el tamaño máximo de 10 MB.";
  }
  const name = String(file.name || "").toLowerCase();
  const blocked = [".exe", ".js", ".bat", ".cmd", ".sh", ".ps1", ".msi", ".dll", ".scr", ".vbs"];
  if (blocked.some((ext) => name.endsWith(ext))) {
    return "Tipo de archivo no permitido.";
  }
  const allowed = [".pdf", ".xml", ".jpg", ".jpeg", ".png", ".doc", ".docx", ".xls", ".xlsx"];
  const hasAllowedExt = allowed.some((ext) => name.endsWith(ext));
  if (!hasAllowedExt) {
    return "Extensión no permitida. Use PDF, XML, imágenes u Office.";
  }
  return "";
}

export const WORKSPACE_CHAT_DEFAULT_LIMIT = 100;
export const WORKSPACE_CHAT_MAX_LIMIT = 500;
export const WORKSPACE_CHAT_DEFAULT_RECENT_DAYS = 30;

export const WORKSPACE_CHAT_RECENT_HINT =
  "Mostrando mensajes recientes. Puedes cargar historial anterior.";

/** Lista de mensajes — Panel General (embebido): más alta y adaptable al viewport. */
export const WORKSPACE_CHAT_EMBEDDED_LIST_CLASS =
  "min-h-[28rem] max-h-[70vh]";

/**
 * Lista de mensajes — BNT Asistente (composer fijo abajo).
 * Sin min-height fijo: la lista ocupa el espacio restante y el input queda visible.
 */
export const WORKSPACE_CHAT_ASISTENTE_LIST_CLASS =
  "flex-1 min-h-0 h-full max-h-none";

/** Lista de mensajes — página /equipo/chat completa. */
export const WORKSPACE_CHAT_FULLPAGE_LIST_CLASS = "max-h-72";

/** Parámetros GET /workspace/chat/messages para listado paginado. */
export function buildWorkspaceChatListParams({
  limit = WORKSPACE_CHAT_DEFAULT_LIMIT,
  before = "",
  after = "",
  dateFrom = "",
  dateTo = "",
  includeOlder = false,
  channel = "group",
  recipientUserId = "",
} = {}) {
  const params = { limit: Math.min(Math.max(Number(limit) || WORKSPACE_CHAT_DEFAULT_LIMIT, 1), WORKSPACE_CHAT_MAX_LIMIT) };
  if (before) params.before = before;
  if (after) params.after = after;
  if (dateFrom) params.date_from = dateFrom;
  if (dateTo) params.date_to = dateTo;
  if (includeOlder) params.include_older = true;
  const channelNorm = String(channel || "group").trim().toLowerCase();
  if (channelNorm === "direct") {
    params.channel = "direct";
    const recipient = String(recipientUserId || "").trim();
    if (recipient) params.recipient_user_id = recipient;
  } else {
    params.channel = "group";
  }
  return params;
}

/** Fusiona mensajes por id preservando orden ascendente por created_at. */
export function mergeWorkspaceChatMessages(existing, incoming, { prepend = false } = {}) {
  const map = new Map();
  for (const msg of existing || []) {
    if (msg?.id) map.set(msg.id, msg);
  }
  for (const msg of incoming || []) {
    if (msg?.id) map.set(msg.id, msg);
  }
  const merged = Array.from(map.values());
  merged.sort((a, b) => String(a.created_at || "").localeCompare(String(b.created_at || "")));
  if (prepend && incoming?.length) {
    return merged;
  }
  return merged;
}
